module.exports = {
  "dateRange": function dateRange(args) {
    return "No ".concat(args.startDate, " l\u012Bdz ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "Atlas\u012Bts: ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "Noklik\u0161\u0137iniet, lai pabeigtu datumu diapazona atlasi",
  "maximumDate": "P\u0113d\u0113jais pieejamais datums",
  "minimumDate": "Pirmais pieejamais datums",
  "next": "T\u0101l\u0101k",
  "previous": "Atpaka\u013C",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Atlas\u012Btais datums: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Atlas\u012Btais diapazons: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Noklik\u0161\u0137iniet, lai s\u0101ktu datumu diapazona atlasi",
  "todayDate": function todayDate(args) {
    return "\u0160odien, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Atlas\u012Bta \u0161odiena, ".concat(args.date);
  }
};